import React from "react";
import Marquee from "react-fast-marquee";
import styled from "styled-components";

export const Marque = () => {
  // Array of icon names
  const icons = [
    "HTML",
    "CSS",
    "JavaScript",
    "Typescript",
    "ReactJs",
    "React Native",
    "styled-components",
    "Hooks",
    "Redux",
    "REST APIs",
    "GraphQL",
    "Material UI",
    "NodeJs",
    "ExpressJs",
    "Git",
    "GitHub",
    "Netlify",
    "Figma",
  ];

  return (
    <App>
      <MarqueeContainer>
        <Marquee direction="right" speed={80} delay={0}>
          {icons.map((icon, index) => (
            <ImageWrapper key={index}>
              <p>{icon}</p>
            </ImageWrapper>
          ))}
        </Marquee>
      </MarqueeContainer>
    </App>
  );
};

const App = styled.div`
  margin: 50px 0 100px 0;
  text-align: center;
  width: 100%;
  position: relative;
  overflow: hidden;

  /* Smoke effect on both sides */
  mask-image: linear-gradient(
    to right,
    transparent 0%,
    black 10%,
    black 90%,
    transparent 100%
  );
  -webkit-mask-image: linear-gradient(
    to right,
    transparent 0%,
    black 10%,
    black 90%,
    transparent 100%
  );

  /* Fade-in animation on load */
  opacity: 0.5;
  animation: fadeIn 1s ease-in-out forwards;

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }
`;

const MarqueeContainer = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  position: relative;
`;

const ImageWrapper = styled.div`
  margin: 0px 30px;
  background: linear-gradient(45deg, #c3c2c292, #ffffffaa);
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  height: 80px;
  display: flex;
  text-align: center;
  align-items: center;
  padding-inline: 20px;
  p {
    font-size: 30px;
  }
`;
